const users = [
  {
    path: '/clients',
    name: 'clients.list',
    component: () => import('@/views/clients/ClientList.vue'),
  },
]

export default users
